const ForgotPasswordSchema = {
  type: "object",
  properties: {
    email: {
      type: "string",
      title: "Email",
      required: true,
      "x-decorator": "FormItem",
      "x-component": "Input",
    },
  },
};

export default ForgotPasswordSchema;
